import { GraphqQlApi } from '@/api/api.js'
import DataSourceBase from '../DataSourceBase'
import moment from 'moment'

let data = {
  consumptionCounters: null,
  selectedConsumptionCounter: null,
  templateFile: null,
  fileName: null,
  yearMonth: null,
  limit: null
}

export default class ClaimedFactADataSource extends DataSourceBase {
  constructor(Vue, id) {
    super(Vue, id, data)
    
    Vue.$root.$on('unlicchanged', () => {
      this.refresh()
    })
  }

  // eslint-disable-next-line no-unused-vars
  callAction(actionName, params) {
    if (actionName == 'getTemplateFile') {
      this.getTemplateFile()
      return
    }

    if (actionName == 'sendFileConsumption') {
      if (this.getData().fileName === null) {
        this.$store.commit('SET_NOTIFY', { text: 'Файл не прикріплено!' })
        return
      }
      this.sendFileConsumption()
      return
    }
  }

  /** Перечитка данных и обновление данных в store  */
  refresh() {
    let unlic = this.getUnlic()
    let thisData = this.getData()
    if (!unlic) {
      this.$store.commit('SET_NOTIFY', { text: 'Оберіть особовий рахунок!' })
      return
    }
    this.$store.commit('SET_PROCESSING', true)
    GraphqQlApi.callOperation({ operationId: 'consumptionCounters' }, { unlic: unlic }).then(response => {
      this.$store.commit('SET_PROCESSING', false)
      thisData.consumptionCounters = response.data.energyAccountQuery.counsumptionCounters.data
      thisData.selectedConsumptionCounter = thisData.consumptionCounters[0].value
    })
    let now = moment().format('YYYY MM')
    thisData.yearMonth = now.replace(' ', '')
    this.$store.commit(`${this.getStoreModuleName()}/setData`, thisData)
  }

  sendFileConsumption() {
    let unlic = this.getUnlic()
    let thisData = this.getData()
    this.$store.commit('SET_PROCESSING', true)
    GraphqQlApi.callOperation({ operationId: 'saveFileConsumption' }, { unlic: unlic, uncounter: thisData.selectedConsumptionCounter, yearmonth: thisData.yearMonth, filePath: thisData.fileName, isplan: false }).then(() => {
      this.$store.commit('SET_PROCESSING', false)
      this.$store.commit('SET_NOTIFY', { text: 'Відправлено' })
      thisData.fileName = null
      this.$store.commit(`${this.getStoreModuleName()}/setData`, thisData)
    })
  }

  getTemplateFile() {
    let unlic = this.getUnlic()
    if (!unlic) {
      this.$store.commit('SET_NOTIFY', { text: 'Оберіть особовий рахунок!' })
      return
    }
    let uncounter = this.getData().selectedConsumptionCounter
    GraphqQlApi.callOperation({ operationId: 'consumptionGroupATemplateFile' }, { unlic: unlic, yearmonth: this.getData().yearMonth, uncounter: uncounter, isplan: false }).then(response => {
      let url = response.data.energyAccountQuery.consumptionGroupATemplateFile.data.fileUri
      this.openInNewTab(url)
    })
  }

  openInNewTab(url) {
    var win = window.open(url, '_blank')
    win.focus()
  }

  getUnlic() {
    return this.$router.currentRoute.query.unlic
  }
}